"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelBodyChildren = void 0;
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const withLoading_1 = require("../../hocs/withLoading");
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const KeyboardBackspace_1 = __importDefault(require("@mui/icons-material/KeyboardBackspace"));
const Breadcrumbs_1 = __importDefault(require("@material-ui/core/Breadcrumbs"));
const ChevronRightOutlined_1 = __importDefault(require("@material-ui/icons/ChevronRightOutlined"));
const ReportOptionsColumn_1 = __importDefault(require("../ReportTable/ReportOptionsColumn"));
const UpdateFolderModal_1 = require("../FoldersPage/UpdateFolderModal");
const useStyles = (0, core_1.makeStyles)((theme) => ({
    navLink: {
        color: components_1.StyleVariables.colors.black,
    },
    container: {
        minHeight: '94%',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        backgroundColor: components_1.StyleVariables.colors.white,
    },
    subSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    children: {
        margin: theme.spacing(3),
    },
    back: {
        borderRadius: 205,
        color: components_1.StyleVariables.colors.black,
        padding: '8px 24px 8px 20px',
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.grey2,
        },
        '&:active': {
            backgroundColor: components_1.StyleVariables.colors.border.default,
        },
    },
    backIcon: {
        marginRight: theme.spacing(1),
        color: components_1.StyleVariables.colors.grey4,
    },
    breadcrumb: {
        fontWeight: components_1.StyleVariables.fonts.weight.medium,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.regular,
    },
    backText: {
        lineHeight: components_1.StyleVariables.fonts.lineHeight.regular,
    },
    panelSettings: {
        marginLeft: 'auto',
        order: 2,
    },
    subTitle: {
        lineHeight: components_1.StyleVariables.fonts.lineHeight.regular,
        padding: '16px 0',
    },
    kebabMenu: {
        marginRight: 4,
    },
}));
const PanelSection = ({ routes, children, panelSettings, footer, isLoading, enableGoBack, disableBreadCrumb, subTitle, enableEdit, enableDelete, currentFolderId, }) => {
    const panelBodyWithLoading = (0, withLoading_1.withSkeletonLoading)(exports.PanelBodyChildren);
    const history = (0, react_router_dom_1.useHistory)();
    const classes = useStyles();
    const setUpdateFolderVisibility = (0, recoil_1.useSetRecoilState)(UpdateFolderModal_1.updateFolderModalVisibleState);
    const handleEditClick = () => {
        setUpdateFolderVisibility(true);
    };
    const getBackButton = () => {
        if (enableGoBack && history.length > 1) {
            return (react_1.default.createElement(core_1.IconButton, { "aria-label": "back", onClick: history.goBack, className: classes.back, disableRipple: true },
                react_1.default.createElement(KeyboardBackspace_1.default, { className: classes.backIcon }),
                react_1.default.createElement(components_1.Text, { as: "h6", className: classes.backText }, "Back")));
        }
        return null;
    };
    const getBreadcrumbs = () => {
        return routes?.map((route, i) => {
            const last = routes.indexOf(route) === routes.length - 1;
            return last ? (react_1.default.createElement("span", { className: classes.navLink, key: i },
                react_1.default.createElement(components_1.Text, { as: "h5", className: classes.breadcrumb, "data-testid": route.displayName }, route.displayName))) : (react_1.default.createElement(react_router_dom_1.NavLink, { to: route.path, key: i, className: classes.navLink },
                react_1.default.createElement(components_1.Text, { as: "h5", className: classes.breadcrumb, "data-testid": route.displayName }, route.displayName)));
        });
    };
    const breadcrumbs = getBreadcrumbs();
    return (react_1.default.createElement("section", { className: classes.container },
        react_1.default.createElement("div", { className: classes.subSection },
            routes && !disableBreadCrumb && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Breadcrumbs_1.default, { separator: react_1.default.createElement(ChevronRightOutlined_1.default, null), "data-testid": "breadcrumb", component: 'span' }, breadcrumbs),
                (enableEdit || enableDelete) && (react_1.default.createElement(ReportOptionsColumn_1.default, { showEdit: enableEdit, showDelete: enableDelete, editFunction: handleEditClick, className: classes.kebabMenu, enableDelete: enableDelete, currentFolderId: currentFolderId })))),
            getBackButton(),
            react_1.default.createElement("div", { className: classes.panelSettings }, panelSettings),
            footer),
        react_1.default.createElement(components_1.Text, { className: classes.subTitle }, subTitle),
        children && (react_1.default.createElement("section", null, panelBodyWithLoading({
            children: children,
            isLoading: isLoading ?? false,
        })))));
};
const PanelBodyChildren = ({ children, }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.PanelBodyChildren = PanelBodyChildren;
exports.default = PanelSection;
